<ng-container *transloco="let convert;">
  @if (recipientForm) {
    <section class="alerts-others-add-form" [ngClass]="'tenant-' + tenantName">
      <h3 data-test-id="alerts-others-form-title" tabindex="-1" #formHeading><ng-content select="[form-title]"></ng-content></h3>
      @if (showError) {
        <error-message data-test-id="alerts-others-form-error-message"></error-message>
      }
      @if (showSuccess) {
        <success-message data-test-id="alerts-others-form-success-message" [message]="message"></success-message>
      }
      @if (!showCancelWarning) {
        <form [formGroup]="recipientForm" (ngSubmit)="onSubmit()">
          <section class="alerts-others-add-form__user">
            <div class="d-flex flex-column flex-md-row">
              <div class="form-group">
                <label for="alerts-others-name">{{convert('profileManagement.alertsOthers.name')}}</label>
                <input data-test-id="alerts-others-form-user-name-input" type="text" class="form-control" id="alerts-others-name" formControlName="name" aria-required="true"
              [class.is-invalid]="
              recipientForm?.invalid && recipientForm?.controls?.name?.touched && recipientForm?.controls?.name?.errors
            " />
                @if (
                  recipientForm?.invalid && recipientForm?.controls?.name?.touched && recipientForm?.controls?.name?.errors
                  ) {
                  <div data-test-id="alerts-others-form-user-name-error" aria-live="assertive" class="invalid-feedback">
                    {{convert('profileManagement.alertsOthers.enterName')}}
                  </div>
                }
              </div>
              <div class="form-group">
                <app-email-input
                  data-test-id="alerts-others-form-user-email-input"
                  [inputForm]="recipientForm"
                  [emailInputConfig]="emailInputConfig"
                  [translations]="translations"
                  [invalidFormatEmail]="invalidFormatEmail"
                  [emailContainsSpecialChars]="emailContainsSpecialChars">
                </app-email-input>
              </div>
            </div>
            <div class="d-flex flex-column flex-md-row">
              <div class="form-group">
                <label for="alerts-others-role">{{convert('profileManagement.alertsOthers.role')}}</label>
                <input data-test-id="alerts-others-form-user-role-input" type="text" class="form-control" id="alerts-others-role" formControlName="role"
                  aria-required="true" />
              </div>
              <div class="form-group">
                <label for="alerts-others-phone">{{convert('profileManagement.alertsOthers.phone')}}</label>
                <input data-test-id="alerts-others-form-user-phone-input" type="text" class="form-control" id="alerts-others-phone" mask="000-000-0000" formControlName="phone"
              [class.is-invalid]="
              recipientForm?.invalid &&
              recipientForm?.controls?.phone?.touched &&
              recipientForm?.controls?.phone?.errors
            " aria-required="true" />
                <div
                  aria-live="recipientForm?.invalid  && recipientForm?.controls?.phone?.touched && recipientForm?.controls?.phone?.errors"
                  class="invalid-feedback">
                  {{convert('profileManagement.alertsOthers.enterPhoneToContinue')}}
                </div>
              </div>
            </div>
          </section>
          <section class="alerts-others-add-form__settings">
            <h3 data-test-id="alerts-others-form-settings-title" class="focus-outline-none" tabindex="-1">
            {{convert('profileManagement.alertsOthers.alertsAndNotifications')}}</h3>
            <h4 class="mb-0">{{convert('profileManagement.alertsOthers.buy')}}</h4>
            <table class="alerts-others-add-form__table">
              <caption class="d-none">
                {{convert('profileManagement.alertsOthers.buyerAlerts')}}
              </caption>
              <colgroup>
              <col />
              <col class="alerts-others-add-form__setting-value" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">{{convert('profileManagement.alertsOthers.sendlertsWhen')}}</th>
                <th class="text-center" scope="col">{{convert('profileManagement.alertsOthers.email')}}</th>
              </tr>
            </thead>
            <tbody>
              @if (buyAlerts$ | async; as buyAlerts) {
                @for (alert of buyAlerts; track alert; let i = $index) {
                  <tr [ngClass]="{ 'd-none': !checkVisibility(alert) }"
                    [attr.data-test-id]="'alerts-others-form-buy-row-' + i">
                    <td class="alert-settings__options">{{ getAlertDescription(alert) }}</td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input form-control" [id]="alert.type"
                          [attr.data-test-id]="'alerts-others-form-buy-checkbox-' + i"
                          (change)="updateNotification($event, alert)" [checked]="checked(alert.type)"
                          [attr.aria-label]="getAlertDescription(alert)" />
                        <label [for]="alert.type" class="custom-control-label"> </label>
                      </div>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
          @if (showSellerAlerts) {
            <h4 class="mb-0">{{convert('profileManagement.alertsOthers.sell')}}</h4>
            <table class="alerts-others-add-form__table">
              <caption class="d-none">
                {{convert('profileManagement.alertsOthers.tableCaptionSellerAlerts')}}
              </caption>
              <colgroup>
              <col />
              <col class="alerts-others-add-form__setting-value" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">{{convert('profileManagement.alertsOthers.sendlertsWhen')}}</th>
                <th scope="col">{{convert('profileManagement.alertsOthers.email')}}</th>
              </tr>
            </thead>
            <tbody>
              @if (sellAlerts$ | async; as sellAlerts) {
                @for (alert of sellAlerts; track alert; let i = $index) {
                  <tr [ngClass]="{ 'd-none': !checkVisibility(alert) }"
                    [attr.data-test-id]="'alerts-others-form-sell-row-' + i">
                    <td class="alert-settings__options">{{ getAlertDescription(alert) }}</td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input form-control" [id]="alert.type"
                          [attr.data-test-id]="'alerts-others-form-sell-checkbox-' + i"
                          (change)="updateNotification($event, alert)" [checked]="checked(alert.type)"
                          [attr.aria-label]="getAlertDescription(alert)" />
                        <label [for]="alert.type" class="custom-control-label"> </label>
                      </div>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        }
        <div class="alerts-others-add-form__footer mt-1">
          <button data-track-elem="button" data-track-name="Save" data-test-id="alerts-others-form-footer-save-button" class="btn btn-primary"
          type="submit">{{convert('common.btnSave')}}</button>
          <button data-track-elem="button" data-track-name="Cancel" data-track-trigger="close"
            data-test-id="alerts-others-form-footer-cancel-button"
            class="btn btn-secondary bid-buttons btn-outline-secondary" type="button" (click)="close()">
            {{convert('common.btnCancel')}}
          </button>
        </div>
      </section>
    </form>
  } @else {
    <div class="alerts-others-add-form__cancel">
      <p data-test-id="alerts-others-form-cancel-warning-text">{{convert('profileManagement.alertsOthers.addFormCancel')}}</p>
      <div class="exit-warning">
        <button data-track-elem="button" data-track-name="Close"
          data-test-id="alerts-others-form-cancel-confirm-button"
          class="btn btn-secondary bid-buttons btn-outline-secondary" type="button" (click)="confirmCancel.emit()">
          <ng-content select="[confirm-button]"></ng-content>
        </button>
        <button data-track-elem="button" data-track-name="Cancel" data-test-id="alerts-others-form-cancel-back-button" class="btn btn-primary" type="button"
          (click)="showCancelWarning = false">
          <ng-content select="[cancel-button]"></ng-content>
        </button>
      </div>
    </div>
  }
  <button data-track-elem="icon" data-track-name="Close" data-track-trigger="close" type="button"
    data-test-id="alerts-others-form-close-button"
    class="btn btn-link alerts-others-add-form__close" (click)="close()">
    <i class="allycon-glyph-close" aria-hidden="true"></i><span
  class="visually-hidden">{{convert('profileManagement.alertsOthers.addFormClose')}}</span>
</button>
</section>
}
</ng-container>
